import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-intrauterine-insemination',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './intrauterine-insemination.component.html',
  styleUrl: './intrauterine-insemination.component.scss'
})
export class IntrauterineInseminationComponent implements OnInit {

  constructor(private route: Router, private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {

    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/intrauterine-insemination",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);


    this.titleService.setTitle('Intrauterine Insemination (IUI) Treatment in Kannur | Ncare IVF Centre');
    this.metaService.updateTag({
      name: 'description',
      content: 'Get expert Intrauterine Insemination (IUI) treatment at Ncare IVF Center in Kannur. Improve your chances of conception with safe, effective fertility care from trusted specialists.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'Intrauterine Insemination, Intrauterine Insemination Treatment, IUI Treatment, Intrauterine insemination (IUI)'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Intrauterine Insemination (IUI) Treatment in Kannur | Ncare IVF Centre'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Get expert Intrauterine Insemination (IUI) treatment at Ncare IVF Center in Kannur. Improve your chances of conception with safe, effective fertility care from trusted specialists.'
    });
  }
  contactus() {
    this.route.navigate(['/contact-us']);
  }
}
